var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGym(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "100px",
    height: "100px",
    viewBox: "0 0 100 100",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6D6F71",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    d: "M32.528,53.792h34.944 M67.473,46.208H32.528  M87.596,53.792h5.867c2.094,0,3.791-1.698,3.791-3.792c0-2.094-1.697-3.792-3.791-3.792h-5.867 M22.028,46.208 M12.405,46.208  M12.405,46.208H6.538c-2.093,0-3.792,1.698-3.792,3.792c0,2.094,1.699,3.792,3.792,3.792h5.867 M77.973,65.307V53.792  M77.973,34.986v11.222 M22.028,65.307v6.351c0,2.899,2.351,5.251,5.25,5.251c2.899,0,5.25-2.352,5.25-5.251V53.792 M12.405,53.792 v9.846c0,2.737,2.22,4.959,4.959,4.959c2.151,0,3.978-1.375,4.664-3.29 M87.596,46.208v7.584 M32.528,46.208V28.342 c0-2.899-2.351-5.25-5.25-5.25c-2.9,0-5.25,2.351-5.25,5.25v6.644 M22.028,46.208V34.986 M32.528,53.792v-7.584 M12.405,46.208 v7.584 M77.973,34.986v-6.644c0-2.899-2.352-5.25-5.25-5.25c-2.9,0-5.25,2.351-5.25,5.25v17.866 M22.028,46.208v7.584  M77.973,46.208v7.584 M22.028,34.986c-0.687-1.917-2.513-3.29-4.664-3.29c-2.739,0-4.959,2.221-4.959,4.959v9.552 M87.596,46.208 v-9.552c0-2.738-2.219-4.959-4.959-4.959c-2.152,0-3.977,1.373-4.664,3.29 M22.028,65.307V53.792 M77.973,65.307 c0.688,1.915,2.512,3.29,4.664,3.29c2.74,0,4.959-2.222,4.959-4.959v-9.846 M67.473,46.208v7.584 M67.473,53.792v17.865 c0,2.899,2.35,5.251,5.25,5.251c2.898,0,5.25-2.352,5.25-5.251v-6.351"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGym);
export default __webpack_public_path__ + "static/media/gym.3c2927dee96fa26a4c28fb69fc911b5b.svg";
export { ForwardRef as ReactComponent };